import React, {FC} from 'react';

import {EFormMode} from 'components/form';

import {ECustomFormEntityName} from './custom-form-modal-constants';
import {MenuSettingsModal} from './menu-settings';

export const customFormsMapping = {
    [ECustomFormEntityName.menuSettings]: MenuSettingsModal,
};

export interface ICustomFormModalProps {
    entityName: ECustomFormEntityName;
    entityId?: string;
    mode: EFormMode;
    handleClose?: () => void;
}

export const CustomFormModal: FC<ICustomFormModalProps> = ({
    entityName,
    entityId,
    mode,
    handleClose,
}: ICustomFormModalProps) => {
    const FormModalComponent = customFormsMapping[entityName as ECustomFormEntityName];
    if (FormModalComponent) {
        return (
            <FormModalComponent
                entityName={entityName}
                entityId={entityId}
                mode={mode}
                handleClose={handleClose}
            />
        );
    }
    return null;
};
